import { mutatorAction } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import type { QuickStepsLoadState } from "../store/schema/QuickStepsLoadState";
import getStore from "../store/store";

export const setQuickStepsLoadStateMutator: (mailboxInfo: MailboxInfo, loadState: QuickStepsLoadState) => void = mutatorAction("setQuickStepsLoadState", (mailboxInfo: MailboxInfo, loadState: QuickStepsLoadState): void => {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const store = getStore();
    store.loadingStatesMap.set(accountKey, loadState);
});
